import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { HeartFilled, HeartOutlined, WarningOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import styles from './SimpleWorkspace.less';

const { Text } = Typography;

export default function ActionProfileSummary({ profiles }) {
  const summary = useMemo(
    () =>
      profiles.reduce(
        (result, item) => ({
          actions: result.actions + 1,
          trained: result.trained + (Number(item.trainingCount) || 0),
          completed: result.completed + (Number(item.completedCount) || 0),
          skipped: result.skipped + (Number(item.skippedCount) || 0),
          liked: result.liked + (Number(item.explicitLikeCount) || 0),
          disliked: result.disliked + (Number(item.explicitDislikeCount) || 0),
          problems:
            result.problems + (Number(item.problemObservationCount) || 0),
        }),
        {
          actions: 0,
          trained: 0,
          completed: 0,
          skipped: 0,
          liked: 0,
          disliked: 0,
          problems: 0,
        },
      ),
    [profiles],
  );
  const facts = [
    { label: '练过动作', value: summary.actions, unit: '个' },
    { label: '累计练习', value: summary.trained, unit: '次' },
    { label: '完成动作', value: summary.completed, unit: '次' },
    { label: '跳过动作', value: summary.skipped, unit: '次' },
    { label: '明确喜欢', value: summary.liked, unit: '次', icon: HeartFilled },
    {
      label: '明确不喜欢',
      value: summary.disliked,
      unit: '次',
      icon: HeartOutlined,
    },
    {
      label: '问题观察',
      value: summary.problems,
      unit: '条',
      icon: WarningOutlined,
    },
  ];

  return (
    <div className={styles.actionProfileSummary}>
      {facts.map((fact) => {
        const Icon = fact.icon;
        return (
          <div key={fact.label} className={styles.actionProfileFact}>
            <Text>{fact.label}</Text>
            <div>
              {Icon && <Icon />}
              <strong>{fact.value}</strong>
              <small>{fact.unit}</small>
            </div>
          </div>
        );
      })}
    </div>
  );
}

ActionProfileSummary.propTypes = {
  profiles: PropTypes.array,
};

ActionProfileSummary.defaultProps = {
  profiles: [],
};
